import { IGetTruckerTypeReturn } from 'services/trucker';

export const mockRecommendedTruckersResponse: IGetTruckerTypeReturn = {
  data: [
    {
      _id: '1',
      person: {
        id: '123',
        uuid: 'uuid2',
        name: 'Maria Souza',
        selfieUri: '',
        areaCodes: [789, 92],
        isVip: false,
        verified: true,
        whereIs: 'Rodovia BR-116, KM 45',
      },
      vehicle: {
        id: 'LeKWZ',
        typeName: 'Caminhão Truck',
        bodyName: 'Baú',
      },
      lastLocation: {
        coordinate: {
          lat: -23.5505,
          lng: -46.6333,
        },
        distance: 150,
      },
    },
  ],
  meta: {
    truckersLimitsTotal: {
      locked: 5,
      unlocked: 15,
    },
    freight: {
      code: 'FRT123',
      origin: {
        city: 'São Paulo',
        federativeUnit: 'SP',
      },
      destination: {
        city: 'Rio de Janeiro',
        federativeUnit: 'RJ',
      },
      vehicleTypes: [
        {
          category: 'Pesados',
          types: [
            { id: 1, name: 'Caminhão 3/4' },
            { id: 2, name: 'Caminhão Toco' },
          ],
        },
      ],
    },
    areaCodes: [
      {
        areaCode: 11,
        text: 'São Paulo e região',
      },
    ],
    pagination: {
      next: null,
      page: 1,
      previous: null,
      total: 1,
      reachedEnd: true,
    },
    extrasTruckers: {
      maxLimitView: 20,
      hasConsumed: true,
      consumption: {
        consumed: 5,
        freeLimit: 15,
        freeAvailable: 10,
      },
    },
  },
};
